// removed by extract-text-webpack-plugin
module.exports = {"instruction-block":"StudentIntakeHeader__instruction-block___2DCUS","divider":"StudentIntakeHeader__divider___2q9DX"};